import SimpleCheckboxWithError from "@/app/components/ui/CheckBoxes/SimpleCheckboxWithError";
import CircleSpinnerLoader from "@/app/components/ui/Reusable/LoaderComponent/CircleSpinnerLoader";
import { useLoader } from "@/app/hooks/useLoader";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import React, { Fragment, useRef } from "react";
import { Controller } from "react-hook-form";

type Props = {
  open: boolean;
  setOpen: (value: boolean) => void;
  handelClick: () => void;
  amount?: any;
  formHook?: any;
};

const SortageAmountModal: React.FC<Props> = ({ open, setOpen, amount, formHook, handelClick }) => {
  const cancelButtonRef = useRef(null);
  const isLoadingCashCollect = useLoader("isCollectAmountDataInProgress");

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => {
            setOpen(false);
          }}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>

            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg text-left p-3 overflow-visible  shadow-xl transform transition-all  sm:align-middle sm:w-full sm:max-w-xl">
                <div className="bg-white px-4   rounded-lg">
                  <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xs font-semibold"> Are you Sure?</h2>
                    <p className="bg-gray-200 flex justify-center items-center h-6 w-6 rounded-full ">
                      <XMarkIcon
                        className="h-4 w-4 cursor-pointer "
                        onClick={() => {
                          formHook.setValue("shortage_reason", null);
                          setOpen(false);
                        }}
                      />
                    </p>{" "}
                  </div>
                  <div className="bg-[#F4F4F4] px-3 py-2 rounded-xl">
                    <p className="text-[#E00101] font-medium text-xl pb-3">
                      Rs. {amount} is shortage in the Final Amount
                    </p>
                    <Controller
                      name="shortage_reason"
                      control={formHook.control}
                      rules={{
                        required: "Explain why there is a shortage.",
                        validate: (value) => value.trim() !== "" || "Reason cannot be blank.",
                      }}
                      render={({ field }) => (
                        <textarea
                          {...field}
                          rows={4}
                          placeholder="Explain why there is a shortage."
                          className="w-full p-2 border border-gray-300 rounded-xl text-sm"
                        />
                      )}
                    />
                    {formHook.formState.errors.shortage_reason && (
                      <p className="text-red-500 text-[10px] mt-1">
                        {formHook.formState.errors.shortage_reason.message as any}
                      </p>
                    )}
                  </div>
                  <div className="flex gap-2 my-4">
                    <SimpleCheckboxWithError
                      register={formHook.register(`short`, {
                        required: true,
                        // ...forOnlyBarcode.validations,
                      })}
                      fieldError={formHook?.formState?.errors?.short}
                      errorMessages={[
                        { message: "is required", type: "required" },
                        // forOnlyBarcode.errors,
                      ]}
                      onChange={() => {
                        const currentPartialValue = formHook.getValues("short");
                        formHook.setValue("short", !currentPartialValue);
                      }}
                      // checked={formHook.watch("partial")}
                      id="partial"
                      colorClassName="text-[#202223] cursor-pointer"
                      className="col-span-1"
                    />
                    <label className="pt-0.5" htmlFor="partial">
                      <p className="text-xs">
                        I take full responsibility for the accuracy of the shortage amount submitted.
                      </p>
                    </label>
                  </div>
                  <div className=" gap-4 w-full mt-3">
                    <button
                      disabled={!formHook.watch("shortage_reason") || isLoadingCashCollect || !formHook.watch("short")}
                      className={clsx(
                        "w-full py-2 text-sm font-medium rounded-md flex items-center justify-center gap-2",
                        {
                          "bg-[#939393] text-white":
                            !formHook.watch("shortage_reason") || isLoadingCashCollect || !formHook.watch("short"), // inactive
                          "bg-black  text-white":
                            formHook.watch("shortage_reason") && !isLoadingCashCollect && formHook.watch("short"), // active
                        },
                      )}
                      onClick={() => {
                        handelClick();
                      }}
                    >
                      {isLoadingCashCollect ? (
                        <div className="">
                          {" "}
                          <CircleSpinnerLoader h="20" w="20" />
                        </div>
                      ) : (
                        "Raise Request"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default SortageAmountModal;
